import React from "react";

const Modal = ({
  iconTitle,
  title,
  message,
  messageElement,
  action,
  actionMessage,
  actionIcon,
  actionClassName = "w-full bg-primary py-4 rounded-xl text-white text-lg mb-4",
  actionStyle,
  actionSecond,
  actionSecondMessage,
  actionSecondIcon,
  actionSecondClassName = "text-black underline mb-2",
  actionSecondStyle,
  content,
  hasCloseButton = true,
  actionClose = actionSecond,
}: {
  iconTitle?: React.ReactElement;
  title?: string;
  message?: string;
  messageElement?: React.ReactElement;
  action?: () => void;
  actionMessage?: string;
  actionIcon?: React.ReactElement;
  actionClassName?: string;
  actionStyle?: React.CSSProperties;
  actionSecond?: () => void;
  actionSecondMessage?: string;
  actionSecondIcon?: React.ReactElement;
  actionSecondClassName?: string;
  actionSecondStyle?: React.CSSProperties;
  content?: React.ReactElement;
  hasCloseButton?: boolean;
  actionClose?: () => void;
}) => {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 flex items-end justify-center">
      <div className="w-full max-w-[calc(480px)] mx-4 mb-4 animate-slide-up">
        {!content && <div className="bg-white rounded-2xl shadow-lg p-6 relative">
          <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-gray-300 rounded-full"></div>
          {hasCloseButton && <button
            type="button"
            onClick={actionClose}
            className="absolute top-6 right-6 text-black"
          >
            <img src="/svg/icon-close.svg" alt="Close" className="w-6 h-6" />
          </button>}
          <div className="w-full flex flex-col items-center pt-4">
            {iconTitle}
            <p className="text-black text-xl font-bold text-center mb-4 mt-5">
              {title}
            </p>
            {(!messageElement && message) && (
              <p className="text-sm text-center text-black mb-6">{message}</p>
            )}
            {messageElement && (
              <div className="text-black mb-6">{messageElement}</div>
            )}
            <button
              type="button"
              onClick={action}
              className={actionClassName}
              style={actionStyle}
            >
              {actionMessage}
              {actionIcon}
            </button>
            {actionSecondMessage && (
              <button
                type="button"
                onClick={actionSecond}
                className={actionSecondClassName}
                style={actionSecondStyle}
              >
                {actionSecondMessage}
                {actionSecondIcon}
              </button>
            )}
          </div>
        </div>}
        {content && <div className="bg-white rounded-2xl shadow-lg p-6 relative">
          {content}
        </div>}
      </div>
    </div>
  );
};

export default Modal;
